import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import Dialog from "../../../components/Dialog";
import S from "../../../styles/pages/HistoryTach/ConfirmPrintModal";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import { StyledFlexDiv } from "../../../styles/MainStyles";
import DialogMessage from "../../../components/DialogMessage";
import DialogMessageProps from "../../../model/DialogMessageProps";
import GenericUtils from "../../../utils/GenericUtils";
import { TypeDialogMessageEnum } from "../../../model/Enums/TypeDialogMessageEnum";
import { getSignedUrlDocument } from "../../../service/Docente/HistoryTachService";

const { BtnPrimary, BtnOutlinePrimary, DefaultButtonLink } = ButtonStyles;

type Modal = {
    open: boolean;
    onClose: () => void;
    visibility?: boolean;
    docId: any;
};

const ConfirmPrintModal = ({ open, onClose, visibility, docId }: Modal) => {
    const { instance } = useMsal();
    const [showDialog, setShowDialog] = useState<boolean>(visibility ?? true);
    const [success, setSuccess] = useState<boolean>(false);
    const [dialogMessageProps, setDialogMessageProps] =
        useState<DialogMessageProps>({} as DialogMessageProps);
    const handleCloseDialogMessage = () => {
        setDialogMessageProps({} as DialogMessageProps);
    };

    const typeDialogMessage = (typeIcon: any) => {
        return success ? TypeDialogMessageEnum.Success : typeIcon;
    };

    const textMessage = (message: any) => {
        if (success) {
            return (
                <span style={{ fontSize: 24, fontWeight: 700 }}>Download</span>
            );
        }

        return message && message.length
            ? message
            : "Ocorreu um erro ao processar sua solicitação.";
    };

    const finishProcess = () => {
        onClose();
    };

    const dialogMessage = dialogMessageProps.show && (
        <DialogMessage
            type={typeDialogMessage(dialogMessageProps.type)}
            show={dialogMessageProps.show}
            title={dialogMessageProps.title}
            text={textMessage(dialogMessageProps.text)}
            onClose={finishProcess}
        />
    );

    const startDownload = (functionSignedUrl: string) => {
        const a = document.createElement("a");
        a.href = functionSignedUrl;
        a.target = "_blank";

        a.style.display = "none";
        document.body.appendChild(a);
        a.click();

        setSuccess(true);
    };

    const downloadAllDocs = async (printAllDocs: boolean) => {
        const response = await getSignedUrlDocument(
            instance,
            docId,
            printAllDocs
        );

        if (GenericUtils.isSuccessStatus(response)) {
            startDownload(response.data.signedUrl);
        }

        const dialog = {
            ...GenericUtils.getPropsDialogError(response),
            onClose: handleCloseDialogMessage,
        };
        setShowDialog(false);
        setDialogMessageProps(dialog);
    };

    const dialogClass = `${showDialog ? "visible-dialog" : "hidden-dialog"}`;

    return (
        <Dialog openModal={open} onHide={onClose} className={dialogClass}>
            <S.StyledTitleModal>
                Gostaria de imprimir os documentos anexados?
            </S.StyledTitleModal>
            <S.StyledButtonContainer>
                <StyledFlexDiv style={{ gap: "10px" }}>
                    <BtnPrimary onClick={() => downloadAllDocs(true)}>
                        Sim
                    </BtnPrimary>
                    <BtnOutlinePrimary onClick={() => downloadAllDocs(false)}>
                        Não
                    </BtnOutlinePrimary>
                </StyledFlexDiv>
                <DefaultButtonLink onClick={onClose}>Voltar</DefaultButtonLink>
            </S.StyledButtonContainer>
            {dialogMessage}
        </Dialog>
    );
};

export default ConfirmPrintModal;
